import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    INFORMATION: {
        id: 'support.header.information',
        defaultMessage: 'Information'
    },
    USER_CUSTOMIZATION: {
        id: 'support.header.userCustomization',
        defaultMessage: 'User customization'
    },
    MULTI_SOURCING_COUNTRIES: {
        id: 'support.header.multiSourcingCountries',
        defaultMessage: 'Multisourcing countries'
    },
    VERSION: {
        id: 'support.version',
        defaultMessage: 'Version'
    },
    CALENDAR_VERSION: {
        id: 'support.calendarVersion',
        defaultMessage: 'Calendar version'
    },
    RELEASE_DATE: {
        id: 'support.releaseDate',
        defaultMessage: 'Release date'
    },
    RESP_HELP_DESK: {
        id: 'support.responsibleHelpDesk',
        defaultMessage: 'Responsible HELP-DESK'
    },
    PHONE: {
        id: 'support.phone',
        defaultMessage: 'Phone'
    },
    EMAIL: {
        id: 'support.email',
        defaultMessage: 'E-mail'
    },
    LANGUAGE: {
        id: 'support.language',
        defaultMessage: 'Language'
    },
    PROFILE: {
        id: 'common.support.profile',
        defaultMessage: 'Profile'
    },
    SWITCH_PROFILE: {
        id: 'common.support.button.switchProfile',
        defaultMessage: 'Switch Profile'
    },
    PROFILE_CHANGE_INITIATED: {
        id: 'common.support.profileChangeInitiated',
        defaultMessage: 'Profile change initiated! Page will be reloaded.'
    },
    LOCATION: {
        id: 'support.location',
        defaultMessage: 'Location'
    },
    TIMEZONE: {
        id: 'support.timezone',
        defaultMessage: 'Time zone'
    },
});

export default messages;
